import { render, staticRenderFns } from "./TvaForm.vue?vue&type=template&id=71348634&"
import script from "./TvaForm.vue?vue&type=script&lang=js&"
export * from "./TvaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71348634')) {
      api.createRecord('71348634', component.options)
    } else {
      api.reload('71348634', component.options)
    }
    module.hot.accept("./TvaForm.vue?vue&type=template&id=71348634&", function () {
      api.rerender('71348634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/tva/components/TvaForm.vue"
export default component.exports